import React from 'react'
import EditRecordForm from '@/components/EditRecordForm';
import { useParams, useNavigate } from 'react-router';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { Loader } from '@/components/ui/loader';

interface Record {
  id: string;
  speciesId: string;
  englishName: string;
  scientificName: string;
  dtm: string;
  count: number;
  lat: number;
  lng: number;
  note: string;
  locationNote: string;
  createdAt: string;
  updatedAt: string;
}

function OrgEditRecord() {
  const { recordId, orgId } = useParams<{ recordId: string, orgId: string }>();

  // Fetch record details
  const { data: record, isLoading: recordLoading, error: recordError } = useQuery({
    queryKey: ['record', recordId],
    queryFn: async () => {
      const response = await fetch(`/api/record/${recordId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch record details');
      }
      return response.json() as Promise<Record>;
    },
    enabled: !!recordId,
  });

  if (recordLoading) {
    return <Loader />
  }

  if (recordError) {
    return <div>Error fetching record details</div>
  }

  return (
    <ActualForm
      recordId={recordId || ''}
      orgId={orgId || ''}
      record={record}
    />
  )


}

const ActualForm = ({ recordId, orgId, record }: { recordId: string, orgId: string, record: Record }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return (
    <EditRecordForm
      recordId={recordId || ''}
      orgId={orgId}
      record={record}
      onSaveComplete={() => {
        queryClient.invalidateQueries({ queryKey: ['record', recordId] });
        navigate(`/app/org/${orgId}/record/${recordId}`);
      }}
      onCancel={() => navigate(`/app/org/${orgId}/record/${recordId}`)}
    />
  )

}

export default OrgEditRecord